<template>
<div>
    <div class="leaderBox" v-if="showOrhide">
		<div class="newtext">新手指引</div>
			<img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../../assets/images/pop/xmxx/xmxx.jpg" class="steps step1" v-if="status=='1'">
			<div class="stepbtn" @click="nextStep(status)">
				{{status=='1'?"我知道了":"我知道了"}}
			</div>
         <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
    <div class="h-crumbOut">
        <div class="h-crumbs">
            <el-breadcrumb separator="|">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item><a href="/xiangmu/pm">项目管理</a></el-breadcrumb-item>
                <el-breadcrumb-item><a href="/xiangmu/Pdetails">项目信息</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div>
	</div>
    <div class="bigDiv">
        <div class="h-piece">
            <div class="top">
                <div class="h-pieceTitle2" style="margin-bottom: 0.4rem;">
                    <h1>项目信息</h1>
                    <img v-if="formLabelAlign.isSuccess=='0' && projectType=='3'" src="../../../assets/images/pimg/wei.jpg" style="position:absolute;top:0.68rem;right: 1rem;">
                    <img v-if="formLabelAlign.isSuccess=='1' && projectType=='3'" src="../../../assets/images/pimg/zhongbiao.jpg"  style="position:absolute;top:0.68rem;right: 1rem;">
                </div>
                <div class="pieceCon ccc">
                    <div class="h-pieceCon2">
                        <div class="j_one">
                            <el-form :model="formLabelAlign" label-position="right" :rules="rules" ref="formLabelAlign2" :inline="true"  class="demo-ruleForm h-formbLine">
                                <!--<el-form-item label="创建人" class="h-elformWrap-2"  style="margin-left: 1.1rem;-->
                                            <!--width: 41%;-->
                                            <!--margin-bottom: 0px;" prop="projectName" >-->
                                    <!--<el-input readonly v-model="formLabelAlign.cuname" class="h-input"></el-input>-->
                                <!--</el-form-item>-->
                                <!--<el-form-item label="创建时间" class="h-elformWrap-2" prop="projectDescription" >-->
                                    <!--<div style="width: 100%;border-bottom: 1px solid #dedede;color: #868686;word-break:break-all;padding-left: 0.15rem;">{{formLabelAlign.cdate}}</div>-->
                                <!--</el-form-item>-->
                                <el-form-item label="项目名称" class="h-elformWrap-1" prop="projectName" >
                                    <el-input readonly v-model="formLabelAlign.projectName" class="h-input"></el-input>
                                </el-form-item>
                                <el-form-item label="项目说明" class="h-elformWrap-1" prop="projectDescription" >
                                    <el-input readonly v-model="formLabelAlign.projectName" class="h-input"></el-input>
                                </el-form-item>
                                <!-- 招标项目 -->
                                <el-form-item label="招标项目" class="h-elformWrap-1" prop="proName" v-if="projectType=='5'">
                                    <el-input readonly v-model="formLabelAlign.tenderName" class="h-input"></el-input>
                                </el-form-item>
                                <el-form-item v-if="projectType=='1'" label="项目有效期" class="h-elformWrap-1 yasen" prop="times" >
                                    <template>
                                        <el-date-picker
                                            disabled
                                            :clearable="false"
                                            v-model="times"
                                            type="daterange"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            value-format="yyyy-MM-dd"
                                            style="width:100%;"
                                        >
                                        </el-date-picker>
                                    </template>
                                </el-form-item>
                                <el-form-item v-if="projectType=='1'" label="项目资料" class="h-elformWrap-1" prop="zhfj">
                                    <brupload
                                    :refid = formLabelAlign.id
                                    :reftype = zhxm
                                    :showtime="showtime"
                                    >
                                    </brupload>
                                </el-form-item>
                                <el-form-item v-if="projectType=='3'" label="项目价格承诺书" class="h-elformWrap-1">
                                    <brupload
                                            :refid= formLabelAlign.id
                                            reftype=jgcns
                                            :showtime="false"
                                    >
                                    </brupload>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="n-hu" v-if="projectType=='3'||projectType=='2'">
                <div class="h-pieceTitle2" >
                    <h1>用户信息</h1>
                </div>
                <div class="pieceCon n-bu">
                    <div class="h-pieceCon2">
                        <div class="h-formLine bbb">
                            <el-form :model="formLabelAlign" label-position=right :rules="rules" ref="formLabelAlign2" :inline="true"  class="demo-ruleForm h-formbLine">
                                <el-form-item label="客户名称" class="h-elformWrap-2" prop="customerName">
                                    <el-select v-model="formLabelAlign.customerName"
                                            filterable
                                            disabled
											:class="{'ljjSelectdisabled':true}"
                                            @change="changeCustomer"
                                            >
                                        <el-option
                                            v-for="(item,index) in optionsCustomer"
                                            :key="index"
                                            :label="item.userName"
                                            :value="item.userCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="区域" class="h-elformWrap-2" prop="projectArea">
                                    <el-input v-model="formLabelAlign.projectArea" readonly></el-input>
                                </el-form-item>

                                <el-form-item v-if="projectType=='2'" prop="currencyCode" label="币种"
                                              class="h-elformWrap-2">
                                    <mdmselect category="YLCurrency" :v="formLabelAlign.currencyCode"
                                               :disabled="true"
                                               :showcode="true"
                                               :readonly="true"
                                               v-model="formLabelAlign.currencyCode"></mdmselect>
                                </el-form-item>
                                <el-form-item label="部门科室" v-if="projectType=='3'" class="h-elformWrap-2" prop="customerDept">
                                    <el-input v-model="formLabelAlign.customerDept" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="关键人" class="h-elformWrap-2" prop="keyPerson">
                                    <el-input v-model="formLabelAlign.keyPerson" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="联系电话" class="h-elformWrap-2 " prop="keyPersonTel">
                                    <el-input v-model="formLabelAlign.keyPersonTel" readonly></el-input>
                                </el-form-item>
                                <el-form-item v-if="projectType=='3'" label="预计转化日期"  class="h-elformWrap-2" prop="expectConvertDate">
                                    <template>
                                        <div class=" block">
                                            <el-date-picker
                                                disabled
                                                v-model="formLabelAlign.expectConvertDate"
                                                type="date"
                                                placeholder="--选择--"
                                                value-format="yyyy-MM-dd"
                                            >
                                            </el-date-picker>
                                        </div>
                                    </template>
                                </el-form-item>

                                <el-form-item v-if="projectType=='3'" prop="salesregion" label="销售区域"
                                              class="h-elformWrap-2">
                                    <brselect
                                            :multiple="true"
                                            :disabled="true"
                                            :readonly="true"
                                            category="YlSalesArea_chanpin" :v="formLabelAlign.salesregion"
                                            v-model="formLabelAlign.salesregion"></brselect>
                                </el-form-item>
                                <el-form-item v-if="projectType=='3'" prop="customerChannel" label="客户渠道"
                                              class="h-elformWrap-2">
                                    <brselect
                                            :multiple="true"
                                            :disabled="true"
                                            :readonly="true"
                                            category="sales_region" :v="formLabelAlign.customerChannel"
                                            v-model="formLabelAlign.customerChannel"></brselect>
                                </el-form-item>

                                <el-form-item label="收货单位" class="h-elformWrap-2 " prop="toCompanyname">
                                    <el-input v-model="formLabelAlign.toCompanyname" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="收货地址" class="h-elformWrap-1 ">
                                    <el-input v-model="formLabelAlign.receivingAddress" readonly></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>


            <div class="n-hu" v-if="projectType=='5'">
                <div class="h-pieceTitle2" >
                    <h1>产品信息</h1>
                </div>
                <div>
                    <el-table
                            ref="multipleTable"
                            :data="proProduct"
							:border="true"
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="typeName"
                                min-width="90"
                                label="产品大类">
                        </el-table-column>
                        <el-table-column
                                prop="productName"
                                label="产品型号"
                                min-width="150"
                                :show-overflow-tooltip="true">
								<template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.productName}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="oemDesc"
                                label="规格型号"
                                min-width="150"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.oemDesc}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="xuniFlag"
                                label="产品类型"
                                min-width="100"
                                :show-overflow-tooltip="true">
                            <template scope="scope">
                                {{scope.row.xuniFlag|dictname('xuni_flag')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="productId"
                                label="产品编码"
                                min-width="150"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="productNum"
                                label="采购数量"
                                min-width="90"
                                :show-overflow-tooltip="true">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.productNum}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="productPrice"
                                label="价格"
                                :show-overflow-tooltip="true"
                                width="90">
                        </el-table-column>
                        <el-table-column
                                prop="currency"
                                label="币种"
                                :show-overflow-tooltip="true"
                                width="90">
                        </el-table-column>
                        <el-table-column
                                prop="shuilv"
                                label="税率"
                                :show-overflow-tooltip="true"
                                width="90">
                        </el-table-column>
                        <el-table-column
                                prop="supplierCode"
                                label="供应商编码"
                                :show-overflow-tooltip="true"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                prop="supplierName"
                                label="供应商名称"
                                :show-overflow-tooltip="true"
                                width="140">
                        </el-table-column>
                        <el-table-column
                                prop="productDes"
                                label="产品描述"
                                min-width="150"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.productDes}}
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>


            </div>


<!-- 外销附件上传开始 -->
            <div class="n-hu" v-if="projectType=='2'">
                <div class="h-pieceTitle2" >
                    <h1>附件上传</h1>
                </div>
                <div class="pieceCon n-bu">
                    <div class="h-pieceCon2">
                        <div class="h-formLine bbb">
                            <el-form :model="formLabelAlign" label-position=right :rules="rules" ref="formLabelAlign2" :inline="true"  class="demo-ruleForm h-formbLine">
                                <el-form-item label="PO附件" class="h-elformWrap-2" prop="poId">
                                    <brupload
                                    :refid = formLabelAlign.id
                                    :reftype = wxpo
                                    :showtime="showtime"
                                    >
                                    </brupload>
                                </el-form-item>
                            <el-form-item label="报价单附件" class="h-elformWrap-2" prop="projectArea">
                                <brupload
                                    :refid = formLabelAlign.id
                                    :reftype = wxpi
                                    :showtime="showtime">
                                    </brupload>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
<!-- 外销附件上传结束 -->

            <div class="h-formLine product n-bu" v-if="projectType=='3'||projectType=='2'||projectType=='1'">
                <div class="h-pieceTitle2">
                    <h1>产品信息</h1>
                </div>
                <el-form :model="formLabelAlign" label-position="right" ref="formLabelAlign" :inline="true" v-if="projectType=='3'"
                         :rules="rules" class="demo-ruleForm h-formbLine">
                    <el-form-item label="质保年限" class="h-elformWrap-2" prop="warrantyPeriod">
                        <el-input v-model="formLabelAlign.warrantyPeriod"
                                  placeholder="请输入质保年限" style="width:1.9rem"></el-input>
                        <span class="Z-yuan">年</span>
                    </el-form-item>
                    <el-form-item label="是否改制" class="h-elformWrap-2" prop="formLabelAlign">
                        <el-select v-model="formLabelAlign.isReform" disabled
                                   placeholder="请选择">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="reformFlag" label="改制附件" class="h-elformWrap-2" required>
                        <brupload
                                v-model="formLabelAlign.gzFileUrl"
                                :refid=this.formLabelAlign.id
                                reftype="NXXM_GZFJ"
                                :showtime="false"
                                :limit="1">
                        </brupload>
                    </el-form-item>

                    <el-form-item v-if="projectType=='3'" label="终端合同" class="h-elformWrap-1">
                        <brupload
                                :refid= formLabelAlign.id
                                reftype="项目-终端合同"
                                :showtime="false"
                        >
                        </brupload>
                    </el-form-item>

                    <el-form-item v-if="projectType=='3'" label="招标文件" class="h-elformWrap-1">
                        <brupload
                                :refid= formLabelAlign.id
                                reftype=zbwj
                                :showtime="false"
                        >
                        </brupload>
                    </el-form-item>

                    <el-form-item v-if="projectType=='3'" label="中标公告（带价格）" class="h-elformWrap-2" required>
                        <brupload
                                :refid= formLabelAlign.id
                                reftype="项目-中标公告"
                                :showtime="false"
                        >
                        </brupload>
                    </el-form-item>

                    <el-form-item v-if="projectType=='3'" label="发票" class="h-elformWrap-2" required>
                        <brupload
                                :refid=formLabelAlign.id
                                reftype="项目-发票"
                                :showtime="false"
                                tips="可继续补充发票，但是不能删除，请仔细操作，避免传错文件！"
                                uploadflag
                                :delflag="xmguanliyuan"
                        >
                        </brupload>
                    </el-form-item>

                    <el-form-item label="是否分销" class="h-elformWrap-2" prop="formLabelAlign">
                        <el-select v-model="formLabelAlign.isFenxiao" disabled
                                   placeholder="请选择">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="fenxiaoFlag" label="分销合同" class="h-elformWrap-2" required>
                        <brupload
                                v-model="formLabelAlign.gzFileUrl"
                                :refid=this.formLabelAlign.id
                                reftype="项目-分销合同"
                                :showtime="false"
                                :limit="1">
                        </brupload>
                    </el-form-item>
                </el-form>
                <div style="padding-left: 0.3rem;">
                    <el-table
                        ref="multipleTable"
                        :data="proProduct"
                        style="width: 100%"
						:border="true"
                        >
                        <el-table-column
                            type="index"
                            width="40"
                            label="#">
                        </el-table-column>
                        <el-table-column
                            prop="typeName"
                            min-width="90"
                            label="产品大类"
                         >
                        </el-table-column>
                        <el-table-column
                                prop="productId"
                                label="产品编码"
                                min-width="120"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="productName"
                            label="产品型号"
                            min-width="150"
                            :show-overflow-tooltip="true"
                         >
							<template slot-scope="scope">
								<div style="text-align: left;">
									{{scope.row.productName}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                            prop="productPrice"
                            min-width="110"
                            label="基准价格"
                       >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.productPrice}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="applyPrice"
                                min-width="110"
                                v-if="projectType=='3'"
                                label="申请价格"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.applyPrice}}
                                </div>
                            </template>
                        </el-table-column>
                        <!-- 代理商毛利 = (分销价 - 申请价) / 分销价 * 100% -->
                        <el-table-column
                                prop="agentMaori"
                                min-width="120"
                                v-if="fenxiaoFlag && projectType=='3'"
                                label="代理商毛利">
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{ getAgentMaori(scope.row) }}
                                </div>
                            </template>
                        </el-table-column>
                        <!-- 分销价 -->
                        <el-table-column
                                prop="fenxiaoPrice"
                                min-width="110"
                                v-if="fenxiaoFlag && projectType=='3'"
                                label="分销价">
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{ Number(scope.row.fenxiaoPrice).toFixed(2) || '0.00' }}
                                </div>
                            </template>
                        </el-table-column>
                        <!-- 分销毛利 = (中标价 - 分销价) / 中标价 * 100% -->
                        <el-table-column
                                prop="fenxiaoMaori"
                                min-width="120"
                                v-if="fenxiaoFlag && projectType=='3'"
                                label="分销商毛利">
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{ getFenxiaoMaori(scope.row) }}
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                                prop="biddenPrice"
                                min-width="110"
                                v-if="projectType=='3'"
                                label="中标价格"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.biddenPrice}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="productNum"
                                min-width="110"
                                label="项目产品数量"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.productNum}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="shipmentPrice"
                                min-width="110"
                                v-if:="this.isGnsc"
                                label="经销商出货单价"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.shipmentPrice}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="otherFees"
                                min-width="110"
                                v-if:="this.isGnsc"
                                label="其他费用"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.otherFees}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="otherFeesDesc"
                                min-width="120"
                                v-if:="this.isGnsc"
                                label="其他费用描述"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.otherFeesDesc}}
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                                v-if="projectType=='3' && tejiaflag == '1' "
                                prop="tejiajine"
                                min-width="110"
                                label="特价价格"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.tejiajine}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                v-if="projectType=='3' && tejiaflag == '1' "
                                prop="tejiazl"
                                min-width="90"
                                label="特价总量"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.tejiazl}}
								</div>
							</template>
                        </el-table-column>
                            <el-table-column
                                    v-if="projectType=='3' && tejiaflag == '1' "
                                    prop="tejiayl"
                                    min-width="90"
                                    label="特价余量"
                            >
								<template slot-scope="scope">
									<div style="text-align: right;">
										{{scope.row.tejiayl}}
									</div>
								</template>
                            </el-table-column>

                        <el-table-column
                                v-if="projectType=='1'"
                                prop="expoType"
                                label="产品折扣方式"
                                min-width="150">
                            <template scope="scope">
                                <brselect
                                        :disabled="true"
                                        category="expo_type"
                                        :v="scope.row.expoType"
                                        v-model="scope.row.expoType"
                                        placeholder="请选择"
                                >
                                </brselect>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="projectType=='1'"
                            prop="expoDiscount"
                            min-width="120"
                            label="产品展销折扣(%)"
                        >
                        </el-table-column>
                            <el-table-column
                                v-if="projectType=='1'"
                                prop="expoPrice"
                                min-width="120"
                                label="产品展销单价"
                           >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.expoPrice}}
								</div>
							</template>

                        </el-table-column>
                    </el-table>
                </div>
            </div>
			<div v-if="projectType=='3'">
                <div class="whether"  style="margin: 0.3rem 0;padding: 0;margin-left: 0.3rem;">
                    <span class="whetherTitle">是否中标</span>
                    <template>
                        <el-radio-group  v-model="formLabelAlign.isSuccess" disabled>
                        <!--<el-radio  :label=2>未发布</el-radio>-->
                        <el-radio  :label=1>中标</el-radio>
                        <el-radio  :label=0>丢标</el-radio>
                        </el-radio-group>
                    </template>
                </div>
                <div class="h-formLine weekplandetail2s" style="width: 100%;" v-if="formLabelAlign.isSuccess=='0'||formLabelAlign.isSuccess=='1'">
                    <div>
						<div class="h-pieceTitle2" style="margin-bottom: 0.1rem;">
						    <h1 v-if="formLabelAlign.isSuccess=='1'">中标信息</h1>
						    <h1 v-if="formLabelAlign.isSuccess=='0'">丢标信息</h1>
						</div>
                        <br>
                        <el-form :model="proBidInfoList1[0]" label-position="right"  ref="proBidInfoList1[0]" :inline="true"  class="demo-ruleForm h-formbLine form">
                            <el-form-item label="投标金额" class="h-elformWrap-2" prop="bidTotal" style="margin-bottom: 0.2rem;">
                                <el-input disabled v-model="proBidInfoList1[0].bidTotal" ></el-input>
                                <span class="Z-yuan">万元</span>
                            </el-form-item>
                        <el-form-item v-if="formLabelAlign.isSuccess=='1'" style="margin-bottom: 0.2rem;" label="合同编码" class="h-elformWrap-2" prop="contractCode">
                                <el-input v-model="proBidInfoList1[0].contractCode" readonly style="width:100%"></el-input>
                                <!--<brupload-->
                                        <!--:refid=formLabelAlign.id-->
                                        <!--reftype=htlb-->
                                        <!--:showtime="false"-->
                                <!--&gt;-->
                                <!--</brupload>-->
                            </el-form-item>

                            <el-form-item v-if="formLabelAlign.isSuccess=='1'"  style="margin-bottom: 0;" label="合同附件" class="h-elformWrap-2" prop="fujian">
                                <brupload
                                        :refid=formLabelAlign.id
                                        reftype="htsc"
                                        :showtime="false"
                                        tips="可继续补充合同，但是不能删除，请仔细操作，避免传错文件！"
                                        uploadflag
                                        :delflag="xmguanliyuan"
                                >
                                </brupload>
                            </el-form-item>
                    </el-form>
                </div>
                    <div class="h-formLine product ljjtablepaddings8" v-if="formLabelAlign.isSuccess=='1'" style="margin-left: 0;width: 100%;">
                        <!--<el-form :model="proBidInfo" label-position="right"  ref="proBidInfo" :inline="true"  class="demo-ruleForm h-formbLine">-->
                            <!--<el-form-item label="其他投标品牌" class="h-elformWrap-2" prop="otherBrand">-->
                                <!--<el-input disabled v-model="proBidInfo.otherBrand"  ></el-input>-->
                            <!--</el-form-item>-->
                            <!--<el-form-item label="其他投标公司" class="h-elformWrap-2 " prop="otherComp">-->
                                <!--<el-input disabled v-model="proBidInfo.otherComp"  ></el-input>-->

                            <!--</el-form-item>-->
                            <!--<el-form-item label="其他公司投标总额" class="h-elformWrap-2" prop="otherTotal">-->
                                <!--<el-input disabled v-model="proBidInfo.otherTotal"  ></el-input>-->
                                <!--<span class="yuan">万元</span>-->
                            <!--</el-form-item>-->
                        <!--</el-form>-->
                        <div style="margin-bottom: 0.3rem;padding-left: 0.3rem;">
                            <el-table
                                    ref="multipleTable"
                                    :data="proBidInfoList1"
                                    style="width: 100%"
                                    :border="true"
                            >
                                <el-table-column
                                        type="index"
                                        width="40"
                                        label="#">
                                </el-table-column>
                                <el-table-column
                                        prop="otherBrand"
                                        label="其他投标品牌"
                                >
                                    <template scope="scope">
                                        <el-input class="h-tableInput" v-model="scope.row.otherBrand"
											:class="{'ljjpdetailsdisabled':true}"
											disabled placeholder=""></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="otherModel"
                                        label="投标型号">
                                    <template scope="scope">
                                        <el-input class="h-tableInput" v-model="scope.row.otherModel"
                                                  :class="{'ljjpdetailsdisabled':true}"
                                                  disabled placeholder=""></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="otherComp"
                                        label="其他投标公司"
                                >
                                    <template scope="scope">
                                        <el-input class="h-tableInput" v-model="scope.row.otherComp"
											:class="{'ljjpdetailsdisabled':true}"
											disabled placeholder=""></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="otherTotal"
                                        label="其他公司投标总额"
                                >
                                    <template scope="scope">
                                        <el-input class="h-tableInput" v-model="scope.row.otherTotal"
											:class="{'ljjpdetailsdisabled':true}"
											disabled placeholder=""></el-input>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>

                    </div>
                </div>
			</div>
            <div class="h-formLine product zhongT" v-if="formLabelAlign.isSuccess=='0'">
                <el-form :model="proBidInfo" label-position="right"  ref="proBidInfo" :inline="true"  class="demo-ruleForm h-formbLine">
                    <el-form-item label="中标公司" class="h-elformWrap-2" prop="successComp">
                        <el-input disabled v-model="proBidInfo.successComp"  ></el-input>
                    </el-form-item>
                    <el-form-item label="丢标金额" class="h-elformWrap-2 " prop="failTotal">
                        <span class="yuan">万元</span>
                        <el-input disabled v-model="proBidInfo.failTotal"  ></el-input>
                    </el-form-item>
                    <el-form-item label="丢标原因" class="h-elformWrap-2" prop="failReason">
                        <el-input disabled v-model="proBidInfo.failReason"  ></el-input>
                    </el-form-item>
                </el-form>
            </div>
                <!-- 用户在用产品信息 -->
        <template>
	        <div>
                <div class="h-pieceIn2" v-if="(projectType=='3'||projectType=='2')&&(productInfosHaier||productInfosOther)">
            <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
            <div class="h-pieceTitle2" style="margin-bottom: 0.4rem;">
                <h1>用户在用产品信息</h1>
            </div>
            <div class="h-pieceCon2 ljjtablepaddings8" style="padding-left: 0.3rem;">
                <div class="h-formLine weekplandetail" style="margin-bottom:50px;">
                    <div class="categoryBox">
                        <div class="category" :class="{'active':item==categorys}"
                                @click="selectC(item)" v-for="(item,index) in category"
                                :key="index">{{item}}
                        </div>
                    </div>
                    <div v-if="categorys == '海尔产品'&&productInfosHaier" style="margin-top:20px;">
                        <el-table
                            ref="multipleTable"
                            :data="productInfosHaier"
                            style="width: 100%"
							:border="true"
                            >
                            <el-table-column
                            type="index"
                            width="40"
                            label="#">
                            </el-table-column>
                            <el-table-column
                            prop="category"
                            label="产品大类"
                            width="150">
                                <template scope="scope">
                                    <el-select v-model="scope.row.category"
                                        placeholder="请先选择产品大类"
                                        filterable
                                        disabled
                                        @change="changeBigHaierBig(scope.row,scope.$index)"
                                        class="h-tableInput"
                                        >
                                    <el-option
                                            v-for="(item,index) in optionsProductBig"
                                            :key="index"
                                            :label="item.levelname"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="specificationName"
                            label="产品型号"
							:show-overflow-tooltip="true"
                            width="150">
                            </el-table-column>
                            <!-- <el-table-column
                            prop="specification"
                            label="产品型号"
                            width="150">
                                <template scope="scope">
                                    <el-select v-model="scope.row.specification"
                                        placeholder="请先选择产品型号"
                                        filterable
                                        disabled
                                        class="h-tableInput"
                                        >
                                    <el-option
                                            v-for="(item,index2) in optionsProductHaier[scope.$index]"
                                            :key="index2"
                                            :label="item.levelname"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                                </template>
                            </el-table-column> -->
                            <el-table-column
                            prop="amount"
                            label="产品数量"
                            width="100">
                                <template scope="scope">
                                    <el-input disabled v-model="scope.row.amount" class="h-tableInput" placeholder="请输入"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="barCode"
                            label="条形码"
                            width="150">
                                <template scope="scope">
                                    <el-input disabled v-model="scope.row.barCode" class="h-tableInput" placeholder="请输入"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="isOverdue"
                            label="是否超限期使用"
                            width="150">
                                <template scope="scope">
                                    <brselect disabled category="isOverdue" class="h-tableInput" :v="scope.row.isOverdue" v-model="scope.row.isOverdue"
                            placeholder="--请选择--"></brselect>
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="exfactoryDate"
                            label="出厂日期"
                            width="250">
                                <template scope="scope">
                                    <div class="block" >
                                    <el-date-picker
                                    disabled
                                    v-model="scope.row.exfactoryDate"
                                    type="date"
                                    placeholder="--选择--"
                                    value-format="yyyy-MM-dd"
                                    class="h-tableInput"
                                    :clearable=false >
                                    </el-date-picker>
                                </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="purchaseDate"
                            label="购买日期"
                            width="250">
                                <template scope="scope">
                                    <div class="block">
                                    <el-date-picker
                                    disabled
                                    v-model="scope.row.purchaseDate"
                                    type="date"
                                    placeholder="--选择--"
                                    value-format="yyyy-MM-dd"
                                    class="h-tableInput"
                                     >
                                    </el-date-picker>
                                </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="产品照片"
                                width="150">
                                <template slot-scope="scope">
                                    <brupload
                                    :refid = scope.row.id
                                    :reftype = "jingpinHaier"
                                    :showtime="showtime"
                                    >
                                    <el-button size="small" type="text">上传</el-button>
                                    </brupload>
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="remark"
                            label="备注"
                            width="300">
                                <template scope="scope">
                                    <el-input disabled class="h-tableInput" v-model="scope.row.remark" placeholder="请输入"></el-input>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-if="categorys == '竞品'&&productInfosOther" style="margin-top:20px;">
                        <el-table
                            ref="multipleTable"
                            :data="productInfosOther"
                            style="width: 100%"
                            >
                            <el-table-column
                            type="index"
                            width="40"
                            label="#">
                            </el-table-column>
                            <el-table-column
                            prop="category"
                            label="产品大类"
                            width="150">
                                <template scope="scope">
                                    <el-select v-model="scope.row.category"
                                            placeholder="请先选择产品大类"
                                            filterable
                                            class="h-tableInput"
                                            disabled
                                            >
                                        <el-option
                                                v-for="(item,index) in optionsProductBig"
                                                :key="index"
                                                :label="item.levelname"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column
                            prop="brand"
                            label="产品品牌"
                            width="150">
                                <template scope="scope">
                                    <el-input disabled v-model="scope.row.brand" class="h-tableInput" placeholder="请填写产品型号"></el-input>
                                </template>
                            </el-table-column> -->
                            <el-table-column
                            prop="brandName"
                            label="产品品牌"
                            width="150">
                            </el-table-column>
                            <el-table-column
                            prop="specification"
                            label="产品型号"
                            width="150">
                                <template scope="scope">
                                    <el-input disabled v-model="scope.row.specification" class="h-tableInput" placeholder="请填写产品型号"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="amount"
                            label="产品数量"
                            width="100">
                                <template scope="scope">
                                    <el-input disabled v-model="scope.row.amount" class="h-tableInput" placeholder="请输入"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="barCode"
                            label="条形码"
                            width="150">
                                <template scope="scope">
                                    <el-input disabled v-model="scope.row.barCode" class="h-tableInput" placeholder="请填写产品数量"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="isOverdue"
                            label="是否超限期使用"
                            width="150">
                                <template scope="scope">
                                    <brselect disabled category="isOverdue" class="h-tableInput" :v="scope.row.isOverdue" v-model="scope.row.isOverdue"
                            placeholder="--请选择--"></brselect>
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="exfactoryDate"
                            label="出厂日期"
                            width="150">
                                <template scope="scope">
                                    <div class="block">
                                        <el-date-picker
                                        disabled
                                        v-model="scope.row.exfactoryDate"
                                        type="date"
                                        class="h-tableInput"
                                        placeholder="--选择--"
                                        value-format="yyyy-MM-dd"
                                        >
                                        </el-date-picker>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="purchaseDate"
                            label="购买日期"
                            width="150">
                                <template scope="scope">
                                    <div class="block">
                                        <el-date-picker
                                        disabled
                                        v-model="scope.row.purchaseDate"
                                        class="h-tableInput"
                                        type="date"
                                        placeholder="--选择--"
                                        value-format="yyyy-MM-dd"
                                        >
                                        </el-date-picker>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="产品照片"
                                width="150">
                                <template slot-scope="scope">
                                    <brupload
                                    :refid = scope.row.id
                                    :reftype = "jingpinOther"
                                    :showtime="showtime"
                                    >
                                    <el-button size="small" type="text">上传</el-button>
                                    </brupload>
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="remark"
                            label="备注"
                            width="300">
                                <template scope="scope">
                                    <el-input disabled v-model="scope.row.remark" class="h-tableInput" placeholder="请输入"></el-input>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
	</div>
    </template>

            <div class="h-formLine product n-bu" v-if="projectType=='3'||projectType=='2'||projectType=='1'">
                <div class="h-pieceTitle2">
                    <h1>其他公司产品</h1>
                </div>
                <div style="padding-left: 0.3rem;">
                    <el-table
                            ref="multipleTable"
                            :data="proOtherProduct"
                            style="width: 100%"
                            :border="true"
                    >
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="typeName"
                                min-width="90"
                                label="产品大类"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="productId"
                                label="产品编码"
                                min-width="120"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="productName"
                                label="产品型号"
                                min-width="150"
                                :show-overflow-tooltip="true"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.productName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="productPrice"
                                min-width="110"
                                label="基准价格"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.productPrice}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="applyPrice"
                                min-width="110"
                                v-if="projectType=='3'"
                                label="申请价格"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.applyPrice}}
                                </div>
                            </template>
                        </el-table-column>
                        <!-- 代理商毛利 = (分销价 - 申请价) / 分销价 * 100% -->
                        <el-table-column
                                prop="agentMaori"
                                min-width="120"
                                v-if="projectType=='3'"
                                label="代理商毛利">
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.agentMaori}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="biddenPrice"
                                min-width="110"
                                v-if="projectType=='3'"
                                label="中标价格"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.biddenPrice}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="productNum"
                                min-width="110"
                                label="项目产品数量"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.productNum}}
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>

</div>

<!-- 审批使用 -->
                    <div class="h-table h-mrt30" v-if="(projectType=='1' || projectType=='3' || projectType=='5') && shflag">
                        <div class="h-pieceTitle2 hang">
                            <h1 class="h1" style="margin-left:20px">审批意见</h1>
                            <el-form :model="formLabelAlign" label-position="right" :inline="true"
                                    class="demo-ruleForm h-formbLine ">
                                <el-form-item label="审批意见" class="h-elformWrap-2 " :required="true"
                                        style="margin:30px 0 20px 23px">
                                    <el-input v-model="formLabelAlign.checkMsg" placeholder="请输入"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
<!-- 展会项目维护客户使用 -->
                    <div v-if="projectType=='1'&&whflag" class="N-chan h-piece ljjtablepaddings8" style="margin-top:20px">
                        <div class="h-pieceTitle2" style="margin-top:-10px">
                            <h1>经销商信息</h1>
                        </div>
                        <div>
                        <el-table
                                ref="multipleTable"
                                :data="agent"
                                style="width: 100%"
								:border="true"
                                >
                                <el-table-column
                                type="index"
                                width="40"
                                label="#">
                                </el-table-column>
                                <el-table-column
                                prop="agentCode"
                                label="经销商名称">
                                    <template scope="scope">
                                        <el-select v-model="scope.row.agentCode"
                                                placeholder="请选择经销商"
                                                filterable
												style="width: 100%;"
                                                class="h-tableInput"
                                                    @change="changeAgent(scope.row,scope.$index)"
                                                >
                                            <el-option
                                                    v-for="(item,index) in optionsAgent"
                                                    :key="index"
                                                    :label="item.userName"
                                                    :value="item.userCode">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                prop="agentCode"
                                label="经销商编码">
                                </el-table-column>
                                <el-table-column
                                    label="操作"
                                    width="100"
                                    fixed="right">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small"  @click="delIndex(scope.$index)">删除</el-button>
										<!-- <div class="l-operationBox">
											<span class="l-operationlist br-operation-delete" title="删除该条" @click="delIndex(scope.$index)"></span>
										</div> -->
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="h-tableAdd" @click="adds">
                                <a>新增一行</a>
                            </div>
                        </div>
                    </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button v-if="projectType=='1'&&shflag" class="el-button h-btn h-bBtn el-button--default" :class="projectType=='1'&&whflag?'h-bgwhite':'h-bgblueQ2'" @click="cancelPro">返回</el-button>
                <el-button v-if="projectType!='1'||!shflag"  class="el-button h-btn h-bBtn  el-button--default" :class="projectType=='3'&&shflag?'h-bgwhite':projectType=='1'&&whflag?'h-bgwhite':'h-bgblueQ2'" @click="cancelPro">返回</el-button>

                <el-button v-if="projectType=='1'&&shflag" class="el-button h-btn h-bBtn h-bgred el-button--default" @click="refuse">驳回</el-button>
                <el-button v-if="projectType=='1'&&shflag" class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="pass">通过</el-button>
                <el-button v-if="projectType=='1'&&whflag" class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default"  @click="submitAgent">提交</el-button>

                <el-button v-if="projectType=='3'&&shflag" class="el-button h-btn h-bBtn h-bgred el-button--default" @click="neixiaoshenpi(3)">驳回</el-button>
                <el-button v-if="projectType=='3'&&shflag" class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="neixiaoshenpi(2)">通过</el-button>

                <el-button v-if="projectType=='5'&&shflag" class="el-button h-btn h-bBtn h-bgred el-button--default" @click="caigoushenpi(3)">驳回</el-button>
                <el-button v-if="projectType=='5'&&shflag" class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="caigoushenpi(2)">通过</el-button>
            </div>

        </div>
</template>

<script>
import ss from '../../../api/SystemService';
export default {
    data(){
      return{
          xmguanliyuan:false,
        tejiaflag: '',
        showOrhide:false,
        status:1,
        checked:true,
        toshow:"Pdetails7",
        showtime:false,
        times:[],
        shflag:false,
        whflag:false,
        optionsAgent:[],
        agent:[{agentCode:''}],
        agent2:[],
        proProductwx:{productPrice:'',type:'',productId:''},
        projectType:3,
        proBidInfo:{},
        formInline: {},
        formLabelAlign: {type:3,isSuccess:"2",proBidInfoList:[]},
        optionsCustomer: [],
        //产品信息
        proProduct: [{productPrice:'',type:'',productId:''}],
        //产品信息
        proOtherProduct: [{productPrice:'',type:'',productId:''}],
        //产品大类选项
        optionsProduct1: [],
        //产品小类选项
        optionsProduct2: [],
        optionsArea: [],
        customeInfo: {},
        projectId:'',
        //竞品使用
        //带线表单
        categorys: '海尔产品',
        category: ['海尔产品', '竞品'],
        //附件类别
        jingpinOther:"竞品信息-其他品牌",
        jingpinHaier:"竞品信息-海尔",
        wxpo:"外销项目-PO",
        wxpi:"外销项目-PI",
        zhxm:"展会项目-资料",
        //产品大类选项
        optionsProductBig: [],
        //产品小类选项
        optionsProductHaier: [{}],
        //海尔产品竞品
        productInfosHaier: "",
        //其他品牌产品竞品
        productInfosOther: "",
          proBidInfoList1:[{bidTotal:'',contractCode:'',otherBrand:'',otherModel: '',otherComp:'',otherTotal: '',fujian:''}],
        rules:{},
          reformFlag:false,
          fenxiaoFlag:false,
          gscode:false,
      }
    },
    mounted() {
       // this.selectCustomer();
        this.selectProduct1();
        this.selectBidInfo();
        this.query();
        //竞品使用
        this.selectProductBig();

        // swyl_xiangmgly ：内销项目管理员
        this.xmguanliyuan = this.$store.getters.hasRole('swyl_admin,swyl_xiangmgly');

    },
	created() {
		this.showzhezhao()
	},
    methods: {
		showzhezhao(){
			ss.salesList.toshow(this.toshow).then(rd => {
				console.log(rd)
			    if(rd == false){
			        this.showOrhide = false;
			    }else{
			        this.showOrhide = true;
			    }
			})
		},
        submitAgent(){
            if(this.agent&&this.agent.length>0&&this.agent[0].agentCode){
                this.formLabelAlign.proExhibitionAgentList=this.agent;
                console.log(this.formLabelAlign,"提交经销商");
                ss.ProService.saveExhibitionAgent(this.formLabelAlign).then(rd => {
                    this.$msg.msgs("提交成功");
                    this.$router.push("/xiangmu/pm");
                })
            }else{
                this.$msg.msge("请选择经销商");
            }
        },
        selectBidInfo() {
            //内销查询中标信息
            if(this.$route.query.protype=='3'){
                ss.ProService.bidInfo(this.$route.query.id).then(rd => {
                    console.log("内销查询中标信息", rd)
                    if(rd&&rd.length>0){
                        this.proBidInfo=rd[0];
                    }
                })
            }
        },
        delIndex(index){
            this.agent.splice(index, 1);
            this.agent2.splice(index, 1);
            //console.log(index,"删除一行数据");
        },
        agentOptions(){
            //查询经销商客户信息
            ss.UserCare.agentOptionPm({}).then(rd => {
                console.log("查询经销商信息", rd)
                this.optionsAgent=rd;
            })
        },
        // 计算代理商毛利
        getAgentMaori(row) {
            const applyPrice = Number(row.applyPrice) || 0
            const fenxiaoPrice = Number(row.fenxiaoPrice) || 0
            if (fenxiaoPrice <= 0) return '0.00%'
            const rate = ((fenxiaoPrice - applyPrice) / fenxiaoPrice) * 100
            return rate.toFixed(2) + '%'
        },
        // 计算分销毛利
        getFenxiaoMaori(row) {
            const fenxiaoPrice = Number(row.fenxiaoPrice) || 0
            const biddenPrice = Number(row.biddenPrice) || 0
            if (biddenPrice <= 0) return '0.00%'
            const rate = ((biddenPrice - fenxiaoPrice) / biddenPrice) * 100
            return rate.toFixed(2) + '%'
        },
        changeAgent(v,i){
            this.agent2.splice(i, 1);
            if (_.find(this.agent2, {agentCode: v.agentCode})) {
                this.$msg.msge("该经销商已选择,请勿重复选择!")
                v.agentCode="";
                return;
            }else{
                //获取名字
                var sup=_.filter(this.optionsAgent,{'userCode': v.agentCode});
                v.agentName=sup[0].userName;
                this.agent2.push(v);
                //console.log("sd",v,i);
            }

        },
        //增加海尔产品方法
        //增加产品方法
        adds(){
            var a = {agentCode:''}
            this.agent.push(a)
            console.log(this.agent);
        },
        /*selectCustomer() {
            ss.ProService.customerSelect().then(rd => {
                // console.log("客户名称下拉", rd)
                this.optionsCustomer = rd;
            })
        },*/
        selectProduct1() {
            ss.ProService.product1Select().then(rd => {
                // console.log("产品大类下拉", rd)
                this.optionsProduct1 = rd;
            })
        },
        //大类修改时，当块数据proProduct[i]-v,index-i
        changeBig(v,i){
            v.productId='';
            v.productPrice='';
            //console.log("选中大类v.productId222",v,i);
            this.selectProduct2(v.type,i);
        },
        //大类修改时，查询小类列表 v.type大类id-v,index-i
        selectProduct2(v,i) {
            //console.log("3选中大类222",v,i);
            ss.ProService.product2Select(v).then(rd => {
                //console.log("4产品小类下拉", rd)
                //console.log("40产品小类下拉", this.optionsProduct2[i])
                this.optionsProduct2[i] = rd;
                this.$set(this.optionsProduct2,i,rd);
                //console.log(this.optionsProduct2[i],"5产品小类下拉", this.optionsProduct2)
            })
        },
        //小类修改，当块数据proProduct[i]-v
        changeSmail(v) {
            //this.$set(v,"productId",v.productId)
            //v.productId=v.productId;
            var data={mdmMaterialInfoPrice:{materialid:v.productId,leltypecode:1,type:"03",currency:"CNY"}}
            console.log("选中信息2", data)
            ss.ProService.product2Detail(data).then(rd => {
                console.log("选中信息1", 12)
                if(rd.obj&&rd.obj.length>0){
                     console.log("1产品小类详情", rd);
                    v.productPrice=rd.obj[0].mdmMaterialInfoPrice.value;
                }else{
                     //console.log("22产品小类详情", rd);
                    v.productPrice=null;
                }
            })
        },
        changeCustomer(c) {
            console.log("选中信息2", c)
            this.optionsCustomer.forEach((item, index) => {
                if(c==item.userCode){
                    console.log("选中信息2", item)
                    this.formLabelAlign.customerId =item.userCode;
                    this.formLabelAlign.customerName =item.userName;
                    this.formLabelAlign.keyPerson =item.contactuserName;
                    this.formLabelAlign.keyPersonTel =item.telephone;
                    this.formLabelAlign.customerDept=item.department;
                    this.formLabelAlign.projectArea=this.$getDictName("YLRegion",item.areaCode);
                    this.formLabelAlign.customerChannel=this.$getDictName("sales_region",item.channelCode);
                    if(item.userType&&item.userType=='1'){
                        this.formLabelAlign.userType=1
                    }else{
                        this.formLabelAlign.userType=2
                    }
                }
            })
        },
        //查看详情
        query(){
            console.log("sdfsdfsdfsdf");
            var id=this.$route.query.ywid?this.$route.query.ywid:this.$route.query.id;
            console.log(id);
            if(this.$route.query.ywid&&this.$route.query.taskstatus=='0'){
                this.shflag=true;
            }
            if(this.$route.query.whflag=='1'){
               this.whflag=true;
                //加载带选择的经销商
                this.agentOptions();
            }
            ss.ProService.proDetail(id).then(rd => {
                console.log(rd, "项目列表");
                console.log(this.proBidInfo);

                this.formLabelAlign = rd;
				if (rd.proBidInfoList!=null&&rd.proBidInfoList.length>0) {
					this.proBidInfoList1=rd.proBidInfoList;
				}
                console.log(this.proBidInfoList1,'heihei');
                // this.formLabelAlign.customerChannel=this.$getDictName("sales_region", rd.customerChannel);
                // this.formLabelAlign.projectArea=this.$getDictName("YLRegion", rd.projectArea);

                //项目类型赋值
                this.projectType=this.formLabelAlign.type;
                this.tejiaflag = this.formLabelAlign.tejiaflag || '';
                if(this.projectType=='1'){
                    //如果是展会项目类型
                    this.proProduct=rd.proProductInfoList;
                    this.times=rd.times;
                    if (this.formLabelAlign.checkMsg) {
                        this.formLabelAlign.checkMsg="";
                    }

                    if(rd.proExhibitionAgentList&&rd.proExhibitionAgentList.length>0){
                        this.agent=rd.proExhibitionAgentList;
                    }
                }else{
                    //客户信息赋值
                    this.changeCustomer(this.formLabelAlign.customerId);
                    this.proProduct=rd.proProductInfoList;
                    this.proOtherProduct=rd.proProductInfoOtherList;

                    this.proProductwx=rd.proProductInfoList;
                    console.log('采购项目', this.proProductwx);
                    if(rd.userProductInfoHaierList&&rd.userProductInfoHaierList.length>0){
                        this.productInfosHaier=rd.userProductInfoHaierList;
                    }
                    if(rd.userProductInfoOtherList&&rd.userProductInfoOtherList.length>0){
                        this.productInfosOther=rd.userProductInfoOtherList;
                    }
                }
                if(this.formLabelAlign.isReform == '1'){
                    this.reformFlag = true;
                }
                if(this.formLabelAlign.isFenxiao == '1'){
                    this.fenxiaoFlag = true;
                }
                if (this.formLabelAlign.gscode == '1RK0' || this.formLabelAlign.gscode == '9390' || this.formLabelAlign.gscode == '6200'
                    || this.formLabelAlign.gscode == '1JC0' || this.formLabelAlign.gscode == '1D90' || this.formLabelAlign.gscode == '9370') {
                    this.isGnsc = true;
                }
            });
        },
        //项目审核
        usercheck(x) {
            this.formLabelAlign.taskid=this.$route.query.taskid;
            this.formLabelAlign.status=x;
            ss.ProService.checkExpoxm(this.formLabelAlign).then(rd => {
                this.$store.dispatch('searchTasktotal');
                this.$msg.alerts("提交成功！",()=>{
                    this.$router.push({path:'/personal/dealCenter'})
                })
            });
        },
        //内销项目审批
        neixiaoshenpi(x) {
            if(x == '2') {
                console.log("进来了");
                //通

                this.usercheck(x)
            }else {
                //驳回
                if(!this.formLabelAlign.checkMsg){
                    this.$msg.msge("请填写审批意见");
                }else{
                    this.usercheck(x)
                }
            }
        },
        //采购项目审核
        caigoucheck(x){
            this.formLabelAlign.taskid=this.$route.query.taskid;
            this.formLabelAlign.status=x;
            ss.ProService.checkCaigou(this.formLabelAlign).then(rd => {
                this.$store.dispatch('searchTasktotal');
                this.$msg.msgs(rd.msg);
                this.$router.back();
            });
        },
        //采购项目审批
        caigoushenpi(x) {
            if(x == '2') {
                this.caigoucheck(x)
            }else {
                //驳回
                if(!this.formLabelAlign.checkMsg){
                    this.$msg.msge("请填写审批意见");
                }else{
                    this.caigoucheck(x)
                }
            }
        },
        //通过按钮
        pass() {
            this.usercheck(2)
        },

        //驳回按钮
        refuse() {
            console.log(this.formLabelAlign.checkMsg,"sss");
            if(!this.formLabelAlign.checkMsg){
                this.$msg.msge("请填写审批意见");
            }else{
                this.usercheck(3)
            }
        },
        cancelPro(){
            //点击返回关闭当前页
            // window.close();
			this.$router.go(-1);
            /*if(this.$route.query.fromType){
                this.$router.push("/xiangmu/pmgys");
            }else{
                this.$router.push("/xiangmu/pm");
            }*/

        },
        //竞品使用
        selectC(item) {
            this.categorys = item;
            console.log(this.categorys)
        },
        delUserProduction1(index){
            this.productInfosHaier.splice(index, 1)
            //console.log(index,"删除一行数据");
        },
        delUserProduction2(index){
            this.productInfosOther.splice(index, 1)
            //console.log(index,"删除一行数据");
        },
        addComp(){
            var id = this.$util.getUuid();
            console.log(id,"----------------");
            var a = {id:id,type:2,fromType:1}
            console.log(a,"----------------");
            this.productInfosOther.push(a)
        },
        addHaier(){
            var id = this.$util.getUuid();
            var a = {id:id,type:1,fromType:1,specification:'',brand:"Haier"}
            this.productInfosHaier.push(a)
        },
        //大类修改时，当块数据proProduct[i]-v,index-i
        changeBigHaierBig(v,i){
            //console.log("1选中大类",v);
            v.specification='';
            //console.log("2选中大类v.productId222",v,i);
            this.selectProductHaier(v.category,i);
        },
        //海尔内部竞品，大类修改时，查询小类列表 v.type大类id-v,index-i
        selectProductHaier(v,i) {
            //console.log("3选中大类222",v,i);
            ss.ProService.product2Select(v).then(rd => {
                //console.log("4产品小类下拉", rd)
                this.optionsProductHaier[i] = rd;
                this.$set(this.optionsProductHaier,i,rd);
                //console.log(this.optionsProductHaier[i],"5产品小类下拉", this.optionsProductHaier)
            })
        },
        selectProductBig() {
            ss.ProService.product1Select().then(rd => {
                console.log("产品大类下拉", rd)
                this.optionsProductBig = rd;
            })
        },
        // 关闭新手引导页
        closeIt(){
            this.showOrhide = false;
            if(this.checked){
                ss.salesList.toshow(this.toshow,this.checked).then(rd => {
                	console.log(rd)
                	this.showOrhide = false;
                })
            }else{
				ss.salesList.toshow(this.toshow,this.checked).then(rd => {
					console.log(rd)
					this.showOrhide = false;
				})
			}
        },
        nextStep(i){
            if(this.status =='1'){
                if(this.checked){
                   ss.salesList.toshow(this.toshow,this.checked).then(rd => {
                   	console.log(rd)
                   	this.showOrhide = false;
                   })
                }else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
            }
        },
    },

}
</script>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
		z-index: 999999;
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;
		}
		.steps{
			position: absolute;
			z-index: 1;
		}
		.step1{
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}

		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.65rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
			z-index: 2;
		}
	}
</style>

<style scoped>
    .Z-yuan{
        position: absolute;
        left: 90%;
    }
    .yuan{
        position: absolute;
        left: 85%;
    }
    .n-bu .h-formbLine .h-elformWrap-2,
    .n-j .h-formbLine .h-elformWrap-2{
        width: 33.333%;
    }
    .pieceCon, .product{
        padding-top: 20px;
        border-radius: 4px;
        margin-left: 15px;
    }

    .ccc{
        margin-top: -13px;
    }
    .N-chan .h-pieceTitle2,.n-hu .h-pieceTitle2{
        margin-bottom: 0.4rem;
        margin-left: 0;
    }
    .whetherTitle{
        margin-right: 20px;
    }
    .zhongT{
        margin-bottom: 20px;
        margin-left: -42px;
    }
    .Z-biao{
        margin-left: 76px;
    }
    .hetong{
        display: inline-block;
        margin-top: 13px;
    }
    .bigDiv{
        margin: 20px;
    }
    h6{
        padding-left: 23px;
        color:#0e75e9;
        font-size: 15px;
    }
    .whether{
        font-size: 0.14rem;
        margin-left: 33px;
        padding-bottom: 20px;
    }
    .bbbb {
        padding-top: 5px;

    }
    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
</style>
<style>
    .bbbb .h-formbLine .el-form-item__label{
        width: 17%;
    }
    .j_one .el-range-editor.is-disabled .el-range-separator{
        margin-bottom: 19px;
    }
    .j_one .h-formbLine .el-form-item__label{
        width: 12.5%;
    }
	.j_one .h-formbLine .el-form-item__content{
	    width: 77.5%;
	}
    .j_one .h-formbLine .h-elformWrap-1 .el-form-item__content{
        width: 79.9%;
    }
    .zhongT .h-formbLine .el-form-item__content,
    .n-bu .h-formbLine .el-form-item__content,
    .n-j .h-formbLine .el-form-item__content{
        width: 57%;
    }
    .zhongT .h-formbLine .el-form-item__label,
    .n-bu .h-formbLine .el-form-item__label,
    .n-chan .h-formbLine .el-form-item__label{
        width: 43%;
    }
    .n-bu .h-formbLine .h-elformWrap-1 .el-form-item__label{
        width: 12%;
    }
    .n-bu .h-formbLine .h-elformWrap-1 .el-form-item__content{
        width: 88%;
    }
    .n-bu .h-formbLine .h-elformWrap-2,
    .n-chan .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }
    .categoryBox {
        display: flex;
        border-bottom: 1px solid #dcdfe1;
    }
    .categoryBox .category {
        width: 1.22rem;
        height: 0.36rem;
        color: #b0b0b0;
        font-size: 0.16rem;
        text-align: center;
        line-height: 0.34rem;
        margin-left: 0.2rem;
        border: 1px solid #b4b4b4;
        cursor: pointer;
        border-bottom: 0;
    }
    .categoryBox .category:first-child{
        margin-left: 0;
    }
    .categoryBox .category.active {
        color: #fff;
        border: 1px solid #1b78e6;
        background: #1b78e6;
    }
	.ljjtablepaddings8 .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.ljjtablepaddings8 .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
	.weekplandetail2s .h-formbLine .el-form-item__label{
		width: 20%;
	}
	.weekplandetail2s .h-formbLine .el-form-item__content{
		width: 80%;
	}
	.ljjpdetailsdisabled.el-input.is-disabled .el-input__inner{
		border-color: transparent;
	}
</style>
